import { useEffect } from 'react'
import { useMap } from '@vis.gl/react-google-maps'

interface FitBoundsProps {
  /** Puntos a encuadrar. Si está vacío, no hace nada. */
  points: google.maps.LatLngLiteral[]
  padding?: number | google.maps.Padding
  /** Tope de zoom tras el encuadre (fitBounds no lo limita por sí solo). */
  maxZoom?: number
  /**
   * Token que, al cambiar, fuerza un reencuadre. Por defecto reencuadra solo
   * cuando cambia el conjunto de puntos (evita resetear el zoom en cada click).
   */
  nonce?: number
}

/** Reencuadra el mapa para contener `points`, opcionalmente limitando el zoom. */
export function FitBounds({ points, padding = 48, maxZoom, nonce }: FitBoundsProps) {
  const map = useMap()
  useEffect(() => {
    if (!map || points.length === 0) return
    const bounds = new google.maps.LatLngBounds()
    points.forEach((p) => bounds.extend(p))
    map.fitBounds(bounds, padding)
    if (maxZoom != null) {
      const listener = google.maps.event.addListenerOnce(map, 'idle', () => {
        const z = map.getZoom()
        if (z != null && z > maxZoom) map.setZoom(maxZoom)
      })
      return () => listener.remove()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [map, points, nonce])
  return null
}
